import axios from 'axios';
import { GetBackendUrlForGlobalFunctions } from '../../../App';
import App1 from '../../../App';

export const getsource_request = (id: number) => {
  return axios.get(
    GetBackendUrlForGlobalFunctions() + `dig/request?where=` + id
  );
};

export const Addsource_request = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(GetBackendUrlForGlobalFunctions() + `dig/request/add`, obj, {
    headers,
  });
};

export const Editsource_request = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(
    GetBackendUrlForGlobalFunctions() + `dig/request/update`,
    obj,
    { headers }
  );
};

export const Deletesource_request = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(
    GetBackendUrlForGlobalFunctions() + `dig/request/delete`,
    obj,
    { headers }
  );
};
export default class RequestSourceService {}
